import { GET_PLATFORM_META } from "@/constants/ActionTypes";
import { IGetPlatformMetaAction } from "@/types/platformMeta.types";

// eslint-disable-next-line import/prefer-default-export
export const getPlatformMetaAction = (
  interviewSlug: string,
): IGetPlatformMetaAction => ({
  type: GET_PLATFORM_META,
  payload: {
    interviewSlug,
  },
});
